import {
  HOME_TO_VISIT_POSTCODE_DISTANCE_ERROR_DISMISS,
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE,
} from '../../../actions/constants/types';
import userMessagesReducerFactory from '../../factories/userMessagesReducerFactory';

const assignmentDistanceMessages = userMessagesReducerFactory(
  [HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE],
  [],
  [HOME_TO_VISIT_POSTCODE_DISTANCE_ERROR_DISMISS],
  [],
  [],
);

export default assignmentDistanceMessages;
